import { EVENT_KEYS, type EventKey, type WebsocketEvent } from '@/types/websocket';
import { debugLog } from '@/utils/logging';

const knownKeys = new Set<string>(EVENT_KEYS);

export function isEventKey(str: string): str is EventKey {
  return knownKeys.has(str as EventKey);
}

export type UserEventHandlers = {
  [K in EventKey]: (event: Extract<WebsocketEvent, { eventKey: K }>) => void;
};

export const createUserChannelEventHandler = (registry: UserEventHandlers) => (key: string, event: WebsocketEvent) => {
  if (!isEventKey(key)) {
    debugLog(`Unknown event key received: ${key}`, 'Pusher');
    return;
  }
  const handler = registry[key] as (event: WebsocketEvent) => void;
  handler(event);
};
